import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Catalogo from "@/pages/Catalogo";
import ProductDetail from "@/pages/ProductDetail";
import Storia from "@/pages/Storia";
import Novita from "@/pages/Novita";
import Contatti from "@/pages/Contatti";
import Promo from "@/pages/Promo";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { TextsProvider } from "@/lib/texts";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <TextsProvider>
        <BrowserRouter>
          <ScrollManager />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<Catalogo />} />
              <Route path="/prodotto/:id" element={<ProductDetail />} />
              <Route path="/storia" element={<Storia />} />
              <Route path="/novita" element={<Novita />} />
              <Route path="/promo" element={<Promo />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </Layout>
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121212", border: "1px solid rgba(212,175,55,0.3)", color: "#FAFAFA" } }} />
        </BrowserRouter>
      </TextsProvider>
    </div>
  );
}

export default App;
